module.exports = __webpack_public_path__ + "static/media/div.56c872da.ico";


//////////////////
// WEBPACK FOOTER
// ./static/images/icons/div.ico
// module id = 89
// module chunks = 0